/**
 * Get a formatted list of classes from an array of strings and objects.
 *
 * - Passing a `string` in the `classes` array directly adds the string to the final class list.
 * - Passing an `object` in the `classes` array adds each key `string` to the final class list
 * where the associated value is `true`.
 */
export const getClasses = (
  ...classes: Array<string | Record<string, boolean | undefined> | undefined>
): string => {
  const classNames: Set<string> = new Set();

  for (const className of classes) {
    if (typeof className === 'string' && className.length > 0) {
      classNames.add(className);
    }

    if (typeof className === 'object' && className !== null) {
      for (const [key, value] of Object.entries(className)) {
        if (value) classNames.add(key);
      }
    }
  }

  return Array.from(classNames).join(' ');
};
